import React, { useEffect } from 'react';
import $ from 'jquery';
import Slider from './Slider';
import Footer from './Footer';
import Topnavigation from './Topnavigation';
import SEO from './SEO';

const features = [
  { img: 'assets/img/books.png', title: 'Well-Curated Study Material', desc: 'Our experienced faculty strive hard for extensive coverage of all courses in the form of lectures, study material and tests.' },
  { img: 'assets/img/student.png', title: 'Experienced Faculty', desc: 'Our faculty add experience and value to student\'s learning with advanced teaching techniques and quick doubt clarification.' },
  { img: 'assets/img/book.png', title: 'Tests & Assessment', desc: 'Our topic-wise tests, major-tests and rigorous feedback mechanism help students know their level of understanding.' },
  { img: 'assets/img/network.png', title: 'Network of Success', desc: 'Strongly networked community of successful students; Ex-students help build connections and offer career guidance.' },
];

const courses = [
  { img: 'assets/img/ssc.jpg', title: 'SSC', desc: 'S.P. (Study-link Pattern) Batches - All Subjects. Commencing from 15th November: Sunday to Sunday and Holidays daily 3 to 4 hrs.' },
  { img: 'assets/img/ssc_1.jpg', title: 'Commerce', desc: 'S.L.B. (Serious Learner\'s Batches). Commencing from 1st week of December: Sunday to Sunday and Holidays daily 3 to 4 hrs.' },
  { img: 'assets/img/ssc_2.jpg', title: 'Science', desc: 'Commencing from 1st week of December. From 15th April to 31st May: Daily 6 Hours in the Morning or Evening.' },
];

const photos = [
  { img: 'assets/img/pens01.jpg' },
  { img: 'assets/img/class00.jpg' },
  { img: 'assets/img/slideg05.jpg' },
  { img: 'assets/img/class03.jpg' },
  { img: 'assets/img/bg_2.jpg' },
  { img: 'assets/img/class02.jpg' },
];

const testimonials = [
  'Upto now my experience with Study-link Classes was superb. The lectures were detailed and interactive. These lectures have improved my thinking skill, ability and given me knowledge.',
  'It has been a very good experience for me and concepts are getting cleared. Personal attention is given. I enjoy coming here. All the teachers teach in such a way that we all understand clearly.',
  'Study-link Classes is a "small package bada dhamaka". No questions can be raised about the level of teaching and values here.',
];

function Home() {
  useEffect(() => {
    function collapseNavbar() {
      if ($('.navbar').offset().top > 50) {
        $('.navbar-fixed-top').addClass('top-nav-collapse');
      } else {
        $('.navbar-fixed-top').removeClass('top-nav-collapse');
      }
    }
    $(window).scroll(collapseNavbar);
    $(document).ready(collapseNavbar);
    return () => $(window).off('scroll', collapseNavbar);
  }, []);

  return (
    <>
      <Topnavigation />
      <SEO
        title="Best Coaching Classes in Indore"
        description="Study-Link Coaching Classes at 72, Ahilya Nagar, Scheme No. 51, 100 Feet Road, Sangam Nagar, Indore - 452006. CBSE/ICSE tutoring, SSC, Commerce, Science & entrance exam coaching. Call +91 7999061255."
        keywords="coaching classes indore, study link indore, SSC coaching indore, CBSE coaching indore, sangam nagar coaching, 100 feet road indore coaching"
        url="/"
      />
      <h1 style={{ position: 'absolute', width: 1, height: 1, overflow: 'hidden', clip: 'rect(0,0,0,0)', whiteSpace: 'nowrap' }}>
        Study-Link Coaching Classes Indore - Best SSC, Commerce and Science Coaching
      </h1>
      <Slider />

      {/* Intro Section */}
      <section style={{ padding: '50px 0', background: '#fff' }}>
        <div className="container">
          <div className="row align-items-center" style={{ gap: '20px 0' }}>
            <div className="col-12 col-md-4">
              <h4 style={{ fontWeight: 700, color: '#333', fontSize: 'clamp(16px, 2vw, 20px)', lineHeight: 1.7 }}>
                Study-Link Coaching Classes at <span style={{ color: '#009999' }}>72, Ahilya Nagar, Scheme No. 51,
                100 Feet Road, Sangam Nagar, Indore - 452006</span>.
              </h4>
            </div>
            <div className="col-12 col-md-8">
              <p style={{ color: '#555', lineHeight: 1.9, fontSize: 15, marginBottom: 0 }}>
                Established in <strong>2014 by Bharat Ghate</strong>, Study-Link offers CBSE/ICSE school tutoring,
                SSC, Commerce, Science, B.Com, B.Sc and entrance exam coaching for engineering &amp; BCA.
                Our commitment to quality education and personal attention makes us one of the most trusted coaching centers in Indore.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Features */}
      <section style={{ padding: '10px 0 60px', background: '#fff' }}>
        <div className="container">
          <div className="row text-center" style={{ gap: '20px 0' }}>
            {features.map((f, i) => (
              <div key={i} className="col-6 col-md-3">
                <img src={f.img} alt={f.title} style={{ width: 80, height: 80, objectFit: 'contain', marginBottom: 16 }} />
                <h5 style={{ fontWeight: 700, fontSize: 'clamp(13px, 1.5vw, 16px)', textTransform: 'uppercase', color: '#333', marginBottom: 10 }}>
                  {f.title}
                </h5>
                <p style={{ color: '#666', fontSize: 14, lineHeight: 1.7 }}>{f.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Courses Offered */}
      <section style={{
        padding: '60px 0',
        backgroundImage: 'url(assets/img/courses_offered.jpg)',
        backgroundSize: 'cover', backgroundPosition: 'center', position: 'relative',
      }}>
        <div style={{ position: 'absolute', inset: 0, background: 'rgba(0,0,0,0.70)' }}></div>
        <div className="container" style={{ position: 'relative', zIndex: 1 }}>
          <div className="text-center mb-4">
            <h2 style={{ color: '#fff', fontWeight: 700, fontSize: 'clamp(22px, 3vw, 36px)' }}>
              Courses <span style={{ color: '#009999' }}>Offered</span>
            </h2>
            <div style={{ width: 60, height: 3, background: '#009999', margin: '12px auto 0' }}></div>
          </div>
          <div className="row justify-content-center" style={{ gap: '20px 0', marginTop: 30 }}>
            {courses.map((c, i) => (
              <div key={i} className="col-12 col-sm-6 col-lg-4">
                <div style={{
                  background: '#fff', borderRadius: 10, overflow: 'hidden',
                  boxShadow: '0 4px 20px rgba(0,0,0,0.15)',
                  transition: 'transform 0.3s',
                }}
                  onMouseEnter={e => e.currentTarget.style.transform = 'translateY(-6px)'}
                  onMouseLeave={e => e.currentTarget.style.transform = 'translateY(0)'}
                >
                  <img src={c.img} alt={c.title} style={{ width: '100%', height: 200, objectFit: 'cover' }} />
                  <div style={{ padding: '16px 18px' }}>
                    <h5 style={{ fontWeight: 700, color: '#333', marginBottom: 8 }}>{c.title}</h5>
                    <p style={{ color: '#666', fontSize: 14, lineHeight: 1.7, marginBottom: 12 }}>{c.desc}</p>
                    <a href="/courses" style={{
                      color: '#009999', fontWeight: 600, fontSize: 14,
                      textDecoration: 'none', borderBottom: '2px solid #009999',
                    }}>Read More →</a>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Highlights / Carousel */}
      <section style={{ padding: '60px 0', background: '#f9f9f9' }}>
        <div className="container">
          <div className="text-center mb-4">
            <h4 style={{ color: '#009999', fontWeight: 700, textTransform: 'uppercase', fontSize: 14, letterSpacing: 2 }}>Highlights</h4>
            <h3 style={{ fontWeight: 700, color: '#333', fontSize: 'clamp(18px, 2.5vw, 28px)' }}>
              We have unique facilities for our students
            </h3>
            <div style={{ width: 60, height: 3, background: '#009999', margin: '12px auto 0' }}></div>
          </div>
          <div className="row align-items-start" style={{ gap: '30px 0', marginTop: 30 }}>
            <div className="col-12">
              <div id="carouselHighlights" className="carousel slide" data-ride="carousel" data-interval="3000">
                <ol className="carousel-indicators">
                  {[0,1,2,3].map(i => (
                    <li key={i} data-target="#carouselHighlights" data-slide-to={i} className={i === 0 ? 'active' : ''}></li>
                  ))}
                </ol>
                <div className="carousel-inner">
                  {['assets/img/upload/original_1.jpg','assets/img/upload/original_2.jpg','assets/img/upload/original_3.jpg','assets/img/upload/original_4.jpg'].map((src, i) => (
                    <div key={i} className={`carousel-item ${i === 0 ? 'active' : ''}`}>
                      <img src={src} alt={`Highlight ${i+1}`} style={{ width: '100%', height: 'auto', maxHeight: 380, objectFit: 'cover', borderRadius: 8 }} />
                    </div>
                  ))}
                </div>
                <a className="carousel-control-prev" href="#carouselHighlights" role="button" data-slide="prev"
                  style={{ width: 40, height: 40, background: '#009999', borderRadius: '50%', top: '50%', transform: 'translateY(-50%)', left: 10, opacity: 1 }}>
                  <span className="carousel-control-prev-icon"></span>
                </a>
                <a className="carousel-control-next" href="#carouselHighlights" role="button" data-slide="next"
                  style={{ width: 40, height: 40, background: '#009999', borderRadius: '50%', top: '50%', transform: 'translateY(-50%)', right: 10, opacity: 1 }}>
                  <span className="carousel-control-next-icon"></span>
                </a>
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* Our Photos */}
      <section style={{ padding: '60px 0', background: '#fff' }}>
        <div className="container">
          <div className="text-center mb-4">
            <h2 style={{ color: '#009999', fontWeight: 700, textTransform: 'uppercase', fontSize: 'clamp(20px, 3vw, 30px)' }}>
              Our Photos
            </h2>
            <div style={{ width: 60, height: 3, background: '#009999', margin: '12px auto 0' }}></div>
          </div>
          <div className="row" style={{ gap: '20px 0', marginTop: 20 }}>
            {photos.map((p, i) => (
              <div key={i} className="col-6 col-md-4">
                <div style={{ borderRadius: 8, overflow: 'hidden', boxShadow: '0 3px 12px rgba(0,0,0,0.1)' }}>
                  <img src={p.img} alt={`Photo ${i+1}`} style={{ width: '100%', height: 180, objectFit: 'cover', display: 'block', transition: 'transform 0.3s' }}
                    onMouseEnter={e => e.currentTarget.style.transform = 'scale(1.05)'}
                    onMouseLeave={e => e.currentTarget.style.transform = 'scale(1)'}
                  />
                </div>
              </div>
            ))}
          </div>
          <div className="text-center mt-4">
            <a href="/gallery" style={{
              display: 'inline-block', background: '#009999', color: '#fff',
              padding: '10px 30px', borderRadius: 6, fontWeight: 600,
              fontSize: 15, textDecoration: 'none',
            }}>View Full Gallery</a>
          </div>
        </div>
      </section>

      {/* Testimonial + Admission */}
      <section style={{
        padding: '60px 0',
        backgroundImage: 'url(/assets/img/bg_2.jpg)',
        backgroundSize: 'cover', backgroundPosition: 'center', position: 'relative',
      }}>
        <div style={{ position: 'absolute', inset: 0, background: 'rgba(0,0,0,0.65)' }}></div>
        <div className="container" style={{ position: 'relative', zIndex: 1 }}>
          <div className="row align-items-center" style={{ gap: '30px 0' }}>

            {/* Admission Card */}
            <div className="col-12 col-md-5">
              <div style={{
                background: '#009999', borderRadius: 10, padding: '40px 30px',
                textAlign: 'center', boxShadow: '0 8px 30px rgba(0,0,0,0.3)',
              }}>
                <h3 style={{ color: '#fff', fontWeight: 800, marginBottom: 4, fontSize: 'clamp(22px, 3vw, 36px)' }}>Admission</h3>
                <h2 style={{ color: '#fff', fontWeight: 900, fontSize: 'clamp(36px, 6vw, 72px)', margin: '4px 0' }}>OPEN</h2>
                <h3 style={{ color: '#fff', fontWeight: 700, marginBottom: 24, fontSize: 'clamp(18px, 2.5vw, 28px)' }}>
                  {new Date().getFullYear()} - {String(new Date().getFullYear() + 1).slice(-2)}
                </h3>
                <a href="https://app.studylinkclassesedu.in/" target="_blank" rel="noopener noreferrer"
                  style={{
                    display: 'inline-block', background: '#fff', color: '#009999',
                    padding: '12px 32px', borderRadius: 6, fontWeight: 700,
                    fontSize: 16, textDecoration: 'none',
                  }}>
                  Admission Now
                </a>
              </div>
            </div>

            {/* Testimonials */}
            <div className="col-12 col-md-7">
              <h2 style={{ color: '#fff', fontWeight: 700, textAlign: 'center', marginBottom: 24, fontSize: 'clamp(18px, 2.5vw, 28px)' }}>
                Our Happy Students Say
              </h2>
              <div id="carouselTestimonials" className="carousel slide" data-ride="carousel" data-interval="5000">
                <div className="carousel-inner">
                  {testimonials.map((t, i) => (
                    <div key={i} className={`carousel-item ${i === 0 ? 'active' : ''}`}>
                      <div style={{ background: 'rgba(255,255,255,0.1)', borderRadius: 10, padding: '30px 25px', textAlign: 'center' }}>
                        <p style={{ color: '#fff', fontSize: 'clamp(14px, 1.5vw, 16px)', lineHeight: 1.9, fontStyle: 'italic', marginBottom: 0 }}>
                          "{t}"
                        </p>
                      </div>
                    </div>
                  ))}
                </div>
                <ol className="carousel-indicators" style={{ bottom: -30 }}>
                  {testimonials.map((_, i) => (
                    <li key={i} data-target="#carouselTestimonials" data-slide-to={i} className={i === 0 ? 'active' : ''}></li>
                  ))}
                </ol>
                <a className="carousel-control-prev" href="#carouselTestimonials" role="button" data-slide="prev"
                  style={{ width: 36, height: 36, background: '#009999', borderRadius: '50%', top: '50%', transform: 'translateY(-50%)', left: -10, opacity: 1 }}>
                  <span className="carousel-control-prev-icon"></span>
                </a>
                <a className="carousel-control-next" href="#carouselTestimonials" role="button" data-slide="next"
                  style={{ width: 36, height: 36, background: '#009999', borderRadius: '50%', top: '50%', transform: 'translateY(-50%)', right: -10, opacity: 1 }}>
                  <span className="carousel-control-next-icon"></span>
                </a>
              </div>
            </div>

          </div>
        </div>
      </section>

      <Footer />
    </>
  );
}

export default Home;
